/* eslint-disable react-refresh/only-export-components */
import React from 'react';

/* eslint-disable react/jsx-sort-props */
export default React.memo((props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11.251.976a1.29 1.29 0 0 0 2.178.584 1.29 1.29 0 0 1 2.166 1.251 1.289 1.289 0 0 0 1.594 1.594 1.29 1.29 0 0 1 1.251 2.167 1.29 1.29 0 0 0 .583 2.177 1.29 1.29 0 0 1 0 2.502 1.29 1.29 0 0 0-.583 2.177 1.29 1.29 0 0 1-1.25 2.167 1.29 1.29 0 0 0-1.595 1.594 1.29 1.29 0 0 1-2.166 1.25 1.29 1.29 0 0 0-2.178.585 1.288 1.288 0 0 1-2.502 0 1.289 1.289 0 0 0-2.178-.584 1.29 1.29 0 0 1-2.166-1.251 1.29 1.29 0 0 0-1.594-1.594 1.29 1.29 0 0 1-1.251-2.167 1.29 1.29 0 0 0-.584-2.177 1.29 1.29 0 0 1 0-2.502 1.29 1.29 0 0 0 .584-2.177 1.29 1.29 0 0 1 1.25-2.167 1.29 1.29 0 0 0 1.595-1.594 1.29 1.29 0 0 1 2.166-1.25A1.29 1.29 0 0 0 8.75.975a1.29 1.29 0 0 1 2.502 0z" />
    <path
      d="m13.912 7.5-5.09 4.75-2.405-2.406"
      stroke="#fff"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
